<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="less">
@import '~@/styles/common';
@import '~@/styles/markdown.less';

body {
  background: #f6f6f6;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;
}

#app {
  max-width: 600px;
  margin: 0 auto;
}

#app header {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/** https://stackoverflow.com/questions/52158705/vuetify-how-to-mark-field-as-required */
.v-input.required .v-label::before {
  content: '* ';
  font-weight: bold;
  color: @antRed;
}
</style>
